/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

export class ManualEventEmitEvent extends Event {
  effectiveTimestamp: number;
  name: string;

  constructor(type: string, effectiveTimestamp: number, name: string) {
    super(type, { bubbles: true });

    this.effectiveTimestamp = effectiveTimestamp;
    this.name = name;
  }
}
